import { render, staticRenderFns } from "./Dnd.vue?vue&type=template&id=3a67f6c2&scoped=true&"
import script from "./Dnd.vue?vue&type=script&lang=js&"
export * from "./Dnd.vue?vue&type=script&lang=js&"
import style0 from "./Dnd.vue?vue&type=style&index=0&id=3a67f6c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67f6c2",
  null
  
)

export default component.exports